import { Modal } from 'rustig';

// SUPER FRAGILE - Can be removed when all pages have been updated to v3
// Associated with PBS.CasePointe.Website.V3.Controllers.ErrorsController.VersionAgnosticErrorModal
// https://matrixpointesoftware.visualstudio.com/CasePointe/_workitems/edit/19304
export class Errors {
  public static httpError(data: any) {
    let content = '<div id="error-modal" data-modal-id="error-modal" class="modal-md"><div class="modal-header"><h2 class="modal-title">' + data.title + '</h2><a class="button button-icon modal-title-close" data-dismiss="on">&#10006;</a></div>' +
      '<div class="modal-content error-details spacer-all">' + data.content + '</div>' +
      '<div class="modal-actions"><div class="modal-primary-actions"><a class="button button-raised button-primary" href="javascript:;" data-dismiss="on">Close</a></div></div></div>'

    Modal.open({
      content: content
    });
  }
}
